import clsx from "clsx";
import { Fragment } from "react";
import { RenderWhen } from "../../../../../components";
import Tooltip from "../../../../../components/tooltip/Tooltip";
import Typography from "../../../../../components/typography/Typography";
import SearchLink from "../../../../search/components/links/SearchLink";
import styles from "./threat-info.module.scss";

type Props = {
  actors?: Array<string>;
  name: string;
  withSearchLinks?: boolean;
};

const formatThreatName = (name?: string) =>
  (name ?? "").split(".").map((item, index) =>
    index === 0 ? (
      item
    ) : (
      <Fragment key={item}>
        .
        <wbr />
        {item}
      </Fragment>
    )
  );

const ThreatInfo = ({ actors, name, withSearchLinks = false }: Props) => {
  const remainingActors = actors?.slice(1) ?? [];

  return (
  <section
    data-testid="report_summary_threat_info_container"
    className={styles.threat_info}
  >
    <RenderWhen
      condition={Boolean(name)}
      fallback={
        <Typography
          variant="h5"
          tag="span"
          className={clsx(styles.threat_info_name)}
          data-testid="report_summary_threat_info_no_threat_found"
        >
          No Threat Found
        </Typography>
      }
    >
      <Typography
        variant="h5"
        tag="span"
        className={styles.threat_info_name}
        data-testid="report_summary_threat_info_name"
      >
        <RenderWhen
          condition={withSearchLinks}
          fallback={formatThreatName(name)}
        >
          <SearchLink keyword="THREATNAME" value={name}>
            {formatThreatName(name)}
          </SearchLink>
        </RenderWhen>
      </Typography>
      <RenderWhen condition={Boolean(actors?.length)}>
        <Typography
          variant="body4"
          tag="span"
          className={clsx("overflow-ellipsis", styles.threat_info_actor)}
          data-testid="report_summary_threat_info_actor_names"
        >
          <RenderWhen condition={withSearchLinks} fallback={actors?.join(", ")}>
            <SearchLink keyword="ACTOR" value={actors?.[0] ?? ""} />
            <RenderWhen condition={remainingActors.length > 0}>
              <Tooltip
                variant="interactive"
                placement="bottom"
                content={
                  <div className={styles.actor_tooltip}>
                    {remainingActors.map((actor, index) => (
                      <Fragment key={actor}>
                        <SearchLink keyword="ACTOR" value={actor} />
                        {index < remainingActors.length - 1 && ", "}
                      </Fragment>
                    ))}
                  </div>
                }
              >
                <span className={styles.more_actors}>
                  (+{remainingActors.length} More)
                </span>
              </Tooltip>
            </RenderWhen>
          </RenderWhen>
        </Typography>
      </RenderWhen>
    </RenderWhen>
  </section>
  );
};

export default ThreatInfo;
